import { useState, useCallback, useEffect } from 'react'
import taskService from '../services/tasks/taskService'
import { showSuccessToast } from '../helpers/toast'

export default function useReports(membertaskId) {
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const fetchReports = useCallback(async () => {
    if (!membertaskId) return
    setLoading(true)
    try {
      const response = await taskService.getReports(membertaskId)
      const data = response.data
      setReports(Array.isArray(data) ? data : Array.isArray(data.results) ? data.results : Array.isArray(data.data) ? data.data : [])
    } catch {
      setReports([])
    } finally {
      setLoading(false)
    }
  }, [membertaskId])

  useEffect(() => {
    fetchReports()
  }, [fetchReports])

  const createReport = useCallback(async (data) => {
    setSubmitting(true)
    try {
      await taskService.createReport({ ...data, membertask_id: membertaskId })
      showSuccessToast('Raporti u krijua.')
      await fetchReports()
      return { success: true }
    } catch (error) {
      // Extract backend errors for the form to display
      const resp = error.response?.data
      let errors = {}
      if (resp) {
        if (resp.Error) {
          errors._general = resp.Error
        } else if (typeof resp === 'object') {
          errors = resp
        }
      }
      return { success: false, errors }
    } finally {
      setSubmitting(false)
    }
  }, [membertaskId, fetchReports])

  const deleteReport = useCallback(async (id) => {
    try {
      await taskService.deleteReport(id)
      showSuccessToast('Raporti u fshi.')
      await fetchReports()
    } catch {
      // error handled by interceptor
    }
  }, [fetchReports])

  const getReportDetails = useCallback(async (id) => {
    const response = await taskService.getReportDetails(id)
    return response.data
  }, [])

  return {
    reports,
    loading,
    submitting,
    createReport,
    deleteReport,
    getReportDetails,
    refresh: fetchReports,
  }
}
